import React from 'react'
import PropTypes from 'prop-types'
import { Listings } from '@pcln/fly-listings'
import once from 'lodash/once'
import { mark } from '@pcln/measure'
import { pclnExpt as flyExpt } from '../../../common/fly-experimentation/fly-experimentation'
import { ClientGlobals } from '../../../common/client-globals/client-globals'
import { PERF_EVENTS } from '../../../common/constants/perfEvents.js'
import { useFeature } from '@pcln/feature-components'
import { getNumSlices } from '../../util/sbs/sbs.util'

// Represents approximate number of listings above the fold. Intended to configure render-in-view in <Listings>
// to immediately render those items to improve UX.
const ALWAYS_RENDER_FIRST_N_LISTINGS = 6

// TODO wrap in container

const memoizedPerfLog = once(perfEvent => mark(perfEvent))

const ListingsComponentWrapper = props => {
  const perfEvent = PERF_EVENTS.renderGraphListingsStart
  memoizedPerfLog(perfEvent)

  // Represents approximate number of listings above the fold. Intended to configure render-in-view in <Listings>
  // to immediately render those items to improve UX.
  // LaunchDarkly Toggles for Dubai expo 2020
  const isExpoToggleLD = useFeature('flights.displayExpoEYEK')
  const isPricelineOnly = useFeature('whiteLabel.isPricelineOnly')

  return (
    <Listings
      pclnExpt={flyExpt}
      product='AIR'
      alwaysRenderFirstN={ALWAYS_RENDER_FIRST_N_LISTINGS}
      initialDeviceWidth={ClientGlobals.initialDeviceWidth}
      isExpoToggleLD={isExpoToggleLD}
      departureSummaryCardStickyTop='73px'
      numSlices={getNumSlices()}
      showBaggageFeeLink={isPricelineOnly}
      {...props}
    >
      {props.xSellAd}
    </Listings>
  )
}

ListingsComponentWrapper.propTypes = {
  ableToSkipDetails: PropTypes.bool,
  activeTabId: PropTypes.object,
  airportToCity: PropTypes.any,
  assetURLs: PropTypes.object,
  brandReference: PropTypes.array,
  calendarPricing: PropTypes.array,
  calendarPricingExpressDeals: PropTypes.array,
  closeBaggageFeeOverlay: PropTypes.func.isRequired,
  closeErrorOverlay: PropTypes.func.isRequired,
  CTAText: PropTypes.string,
  currentMobileFilter: PropTypes.string,
  deeplinkModelToken: PropTypes.string,
  departingFrom: PropTypes.object,
  destination: PropTypes.string,
  displayAds: PropTypes.bool,
  displayErrorPage: PropTypes.bool,
  displayFlexDates: PropTypes.bool,
  displayInfiniteScrollLoadMore: PropTypes.bool,
  displayListings: PropTypes.bool,
  displayLoadMore: PropTypes.bool,
  displayNonStopItins: PropTypes.func,
  exdCarriers: PropTypes.array,
  featureConfig: PropTypes.object,
  fetchedInitialListings: PropTypes.bool,
  flexDatesHelperResults: PropTypes.object,
  flyGaLogic: PropTypes.object.isRequired,
  hasUSDestinationsOnly: PropTypes.bool,
  handleDepartureSliceClick: PropTypes.func,
  handleTabChange: PropTypes.func,
  isDesktop: PropTypes.bool,
  isSliceSelected: PropTypes.bool,
  isSBS: PropTypes.bool,
  selectedDepartureSummaries: PropTypes.array,
  listings: PropTypes.array,
  listingsIsLoading: PropTypes.bool,
  listingsLoadingMessage: PropTypes.string,
  listingsMetaData: PropTypes.object,
  listingsSaleStyle: PropTypes.object,
  loadingMessage: PropTypes.string,
  loadMore: PropTypes.func.isRequired,
  minRetailPrice: PropTypes.number,
  minRetailStops: PropTypes.number,
  nonStopPrice: PropTypes.number,
  onListingItemSelect: PropTypes.func.isRequired,
  onListingsMount: PropTypes.func.isRequired,
  onSliceFilter: PropTypes.func.isRequired,
  onUpsellSelect: PropTypes.func.isRequired,
  openBaggageFeesModal: PropTypes.func.isRequired,
  origin: PropTypes.string,
  pclnGptDartAds: PropTypes.array,
  perPaxPricingText: PropTypes.string,
  hasEuropeFlight: PropTypes.bool,
  returnDate: PropTypes.string,
  returningFrom: PropTypes.object,
  searchKey: PropTypes.string,
  searchRefId: PropTypes.string,
  searchRequest: PropTypes.object.isRequired,
  SETI: PropTypes.array.isRequired,
  setiDetails: PropTypes.object.isRequired,
  showBaggageFeeModal: PropTypes.bool,
  showErrorOverlay: PropTypes.bool,
  showLoadingOverlay: PropTypes.bool,
  showLoadingScreenServerSide: PropTypes.bool,
  slices: PropTypes.array,
  sponsoredCarrier: PropTypes.string,
  stickyLoggedIn: PropTypes.bool,
  tabs: PropTypes.array,
  throttledTrips: PropTypes.object,
  travelDate: PropTypes.string,
  tripType: PropTypes.string,
  userLoggedIn: PropTypes.bool,
  xSellAd: PropTypes.node,
  isShelfEligible: PropTypes.bool,
  priceGuidanceData: PropTypes.object,
  cancellationText: PropTypes.func,
  cancelTextColor: PropTypes.string,
  cancelFooterIcon: PropTypes.element,
  covidDisplayAttributes: PropTypes.object,
  vipTier: PropTypes.string,
  isExpoToggleLD: PropTypes.object,
  showOriginDate: PropTypes.bool,
  clearFilters: PropTypes.func,
  filtersLists: PropTypes.array,
  isReshopExperience: PropTypes.bool,
  reshopPerPersonText: PropTypes.string,
}

export { ListingsComponentWrapper }
